import React from "react";
import { NavLink } from "react-router-dom";
import moment from "moment";
import "../CreteMoreGroup/createMoreGroups.css";
import { IP } from "../../internalServer";
import assets from "../../assets/assets";
import { Calendar, Trash2 } from "lucide-react";

function SingleGroup({ group, onDelete }) {
  const formatDate = (date) => {
    const d = new Date(date);
    d.setUTCHours(d.getUTCHours() + 5);
    d.setUTCMinutes(d.getUTCMinutes() + 30);
    return moment(d).format("D MMMM YYYY");
  };

  return (
    <div
      className="d-flex mb-4 flex-column justify-content-center gap-4 px-4 h-100 position-relative"
      style={{ width: "100%" }}
    >
      {/* DELETE BUTTON */}
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onDelete(group.id);
        }}
        style={{
          position: "absolute",
          right: 30,
          top: 10,
          border: "none",
          background: "white",
          borderRadius: "50%",
          width: 34,
          height: 34,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          cursor: "pointer",
          transition: "all .2s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = "#fee2e2")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "white")}
      >
        <Trash2 size={18} color="#ef4444" />
      </button>

      <NavLink
        className="link"
        to="/groupWiseQuery"
        state={{ groupId: group.id }}
      >
        <div
          className="w-100 d-flex flex-column p-3 text-start"
          style={{
            borderRadius: "1rem",
            boxShadow: "0px 2px 5px rgba(0,0,0,0.3)",
            backgroundColor: "#fff",
          }}
        >
          <div className="d-flex flex-wrap justify-content-between align-items-start gap-3">
            {/* LEFT SIDE */}
            <div className="d-flex align-items-start gap-2 flex-grow-1">
              <img
                className="group_profile_img"
                src={
                  group?.profile_picture
                    ? IP + group?.profile_picture.replace(/^\./, "")
                    : "/group-img/groupImg1.svg"
                }
                alt=""
                onError={(e) => (e.target.src = assets.QueryImg)}
              />

              <div className="d-flex flex-column gap-1">
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: "16px",
                    wordBreak: "break-word",
                  }}
                >
                  {group?.name}
                </span>

                {group?.latest_query && (
                  <span
                    style={{
                      fontSize: "13px",
                      color: "#555",
                      wordBreak: "break-word",
                      width: "500px", // same width for all
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {group?.latest_query?.query}
                  </span>
                )}

                <div className="d-flex align-items-center gap-2 mt-1">
                  <Calendar size={16} />
                  <small style={{ fontSize: "12px", color: "#444" }}>
                    {group?.latest_query
                      ? formatDate(group?.latest_query?.user?.created_at)
                      : ""}
                  </small>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div
              className="d-flex flex-column gap-2"
              style={{ minWidth: "260px", marginRight: "50px" }}
            >
              {/* Class / Section / Subject */}
              <div
                className="px-3 py-2 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: "#f4f4f4",
                  borderRadius: "12px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                }}
              >
                <div className="d-flex flex-column align-items-center">
                  <span style={{ fontSize: "12px", color: "#333" }}>Class</span>
                  <span className="fw-semibold">{group?.standard?.name}</span>
                </div>

                <div className="d-flex flex-column align-items-center">
                  <span style={{ fontSize: "12px", color: "#333" }}>
                    Section
                  </span>
                  <span className="fw-semibold">{group?.section?.name}</span>
                </div>

                <div className="d-flex flex-column align-items-center">
                  <span style={{ fontSize: "12px", color: "#333" }}>
                    Subject
                  </span>
                  <span
                    className="fw-semibold"
                    title={group?.subject?.name}
                    style={{
                      width: "110px", // same width for all
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {group?.subject?.name || "Not Selected"}
                  </span>
                </div>
              </div>

              {/* Total Queries / Pending */}
              <div
                className="px-3 py-2 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: "#f4f4f4",
                  borderRadius: "12px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                }}
              >
                <div className="d-flex flex-column align-items-center">
                  <span style={{ fontSize: "12px", color: "#333" }}>
                    Total Queries
                  </span>
                  <span className="fw-semibold">{group.totalQueryCount}</span>
                </div>

                <div className="d-flex flex-column align-items-center">
                  <span style={{ fontSize: "12px", color: "#333" }}>
                    Pending Queries
                  </span>
                  <span className="fw-semibold">
                    {group.totalPendingQueries}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </NavLink>
    </div>
  );
}

export default SingleGroup;
